// @flow

import React from 'react';
import _ from 'lodash';
import bemify, { toModifiers } from 'bemify-js';

import LoginTitle from 'app/login/components/LoginTitle';
import ZapStepIcons from 'app/common/components/ZapStepIcons';
import 'app/explore/components/ServiceLoginPreview.scss';

import type { KindType } from 'app/common/types';
import type { ServiceType } from 'app/explore/utils/types';

const bem = bemify('explore-service-login-preview');

type LoginPreviewProps = {
  services: ServiceType,
  kind: KindType,
  previewType: string,
};

const isZapierService = service => service.id === 'ZapierAPI';

const finishTitleWithServices = services => {
  if (services.length < 2 || _.find(services, isZapierService)) {
    return 'automate your apps';
  }
  return 'connect your apps';
};

const titles = {
  login: services => `Log in to ${finishTitleWithServices(services)}`,
  'sign-up': services => `Sign up to ${finishTitleWithServices(services)}`,
};

const LoginPreview = ({ services, kind, previewType }: LoginPreviewProps) => (
  <div className={bem(toModifiers({ 'has-services': !_.isEmpty(services) }))}>
    {kind === 'with-title' ? (
      <LoginTitle>{titles[previewType](services)}</LoginTitle>
    ) : null}
    <div className={bem('__services')}>
      {!_.isEmpty(services) ? (
        <ZapStepIcons
          connectIconType="plus"
          kind="large"
          max={3}
          steps={_.map(services, service => ({
            key: service.id,
            isPremium: service.isPremium,
            isHidden: false,
          }))}
        />
      ) : null}
    </div>
  </div>
);

export default LoginPreview;
